export default __webpack_public_path__ + "static/media/music_on.3603076d.svg";